import { InspectionFolder } from './inspectionFolder.model';
import { Inspection } from './inspection.model';
import { InspectionPoint } from './inspectionPoint.model';
import { ISearch } from './ISearch.model';
import { Icon } from './icon.model';
import * as _ from 'lodash';
import { IHost } from './IHost.model';
import { IInspectionVisitor } from './IInspectionVisitor.model';
import { InspectionSession } from './multi-edit.model';

export class InspectionSection implements ISearch, IHost {
  public folders: InspectionFolder[];
  public inspection: Inspection;
  public points: InspectionPoint[] = [];
  public order: number;
  public progression: number;
  public icons: Icon[] = [];
  public etag: Date;
  public inspectionId: string;
  public sessions: InspectionSession[];

  constructor(public id: string, public name: string, public description: string) {
    this.points = [];
    this.icons = [];
    this.sessions = [];
  }

  get sessionIcons(): InspectionSession[] {
    return this.inspection.sessions?.map((s) => {
      const entitySession = new InspectionSession();
      Object.assign(entitySession, s);
      entitySession.highlight = this.sessions?.includes(s);
      return entitySession;
    });
  }

  public search(query: string): boolean {
    const queryToLower = query.toLowerCase();
    return (
      !query ||
      (this.name && this.name.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.description && this.description.toLowerCase().indexOf(queryToLower) !== -1)
    );
  }

  public accept(visitor: IInspectionVisitor): void {
    this.points?.forEach((point) => point.accept(visitor));
  }

  public getProgression(): number {
    this.points = this.points ?? [];
    const donePoints = _.filter(this.points, (p) => p.isDone());
    this.progression = this.points.length === 0 ? 0 : Math.round((donePoints.length / this.points.length) * 100);
    return this.progression;
  }
}
